<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <CRow style="width:45%;"
                          role="dialog"
                          aria-labelledby="modalTitle"
                          aria-describedby="modalDescription">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["DLSP"][obj_DLSPromo.I > 0? "EDLSP": "ADLSP"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAdd">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="10">
                                            <h6 class="card-title section-title">{{this.getLanguage["PM"]["PMI"]}}</h6>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["DLSP"]["PN"]}}<span class="required" /> :</label>
                                            <CInput :placeholder="getLanguage['DLSP']['PN']" size="sm" :value="obj_DLSPromo.PN" @change="v => obj_DLSPromo.PN = v" :disabled="obj_DLSPromo.I > 0" ref="PN"></CInput>
                                            <span class="ErrMsg">{{ ValidationPromoErrMsg('PN','DLSP','PN') }}</span>
                                        </CCol>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["PM"]["AGI"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                        :options="dd_agentgroup"
                                                        :defaultExpandLevel="Infinity"
                                                        :clearable="false"
                                                        :flat="true"
                                                        :placeholder="getLanguage['PM']['AGI']"
                                                        v-model="obj_DLSPromo.AGIT"
                                                        @input="AgentGroupChange"
                                                        :disabled="obj_DLSPromo.I > 0"
                                                        ref="AGI" />
                                            <span class="ErrMsg">{{ ValidationPromoErrMsg('AGIT','PM','AGI') }}</span>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm  inline inline80">{{this.getLanguage["MEM"]["CI"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_currency2"
                                                        :placeholder="getLanguage['MEM']['CI']"
                                                        :disabled="!bool_currencyloaded || obj_DLSPromo.I > 0"
                                                        class="inline inline40"
                                                        :clearable="false"
                                                        v-model="obj_DLSPromo.CI"
                                                        @input="CurrencyChange"
                                                        ref="CI" />
                                            <span class="ErrMsg inline inline40">{{ ValidationPromoErrMsg('CI','MEM', 'CI') }}</span>
                                        </CCol>
                                    </CRow>
                                    <div class='sectionDivider subHeaderHR'></div>
                                    <CRow>
                                        <CCol col="10">
                                            <h6 class="card-title section-title">{{this.getLanguage["DLSP"]["PR"]}}</h6>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <label class="col-form-label-sm inline inline60">{{this.getLanguage["PM"]["PG"]}}<span class="required" /> :</label>
                                            <treeselect class="inline inline60"
                                                        :multiple="false"
                                                        :options="dd_DLSPromoGroup"
                                                        :clearable="false"
                                                        :placeholder="getLanguage['PM']['PG']"
                                                        v-model="obj_DLSPromo.PG"
                                                        :disabled="obj_DLSPromo.I > 0"
                                                        ref="PG" />
                                            <span class="ErrMsg inline inline60">{{ ValidationPromoErrMsg('PG','PM','PG') }}</span>
                                        </CCol>
                                    </CRow>
                                    <div class='sectionDivider subHeaderHR'></div>
                                    <CRow>
                                        <CCol col="10">
                                            <h6 class="card-title section-title">{{this.getLanguage["DLSP"]["PA"]}}</h6>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="11">
                                            <div>

                                                <label class="col-form-label-sm inline inline40" v-if="obj_DLSPromo.PG==1">{{ this.getLanguage['DLSP']['CA'] }}<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                                <label class="col-form-label-sm inline inline40" v-if="obj_DLSPromo.PG==2">{{ this.getLanguage['DLSP']['NOS'] }}<span class="required" /> :</label>
                                                <label class="col-form-label-sm inline inline40" v-if="obj_DLSPromo.PG==2">{{this.getLanguage["AG"]["GP"]}} :</label>
                                            </div>
                                            <div>
                                                <CInput :placeholder="getLanguage['DLSP']['CA']" size="sm" class="inline inline40" :value="ThousandSeparator(obj_DLSPromo.CA, getThousandCurrency ? 3 : 2)" @change="v => obj_DLSPromo.CA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" v-if="obj_DLSPromo.PG==1"></CInput>
                                                <CInput :placeholder="getLanguage['DLSP']['NOS']" size="sm" class="inline inline40" :value="obj_DLSPromo.NOS" @change="v => obj_DLSPromo.NOS = v" v-if="obj_DLSPromo.PG==2"></CInput>
                                                <!--Select Game Provider-->
                                                <treeselect v-if="obj_DLSPromo.PG==2"
                                                            class="inline inline40"
                                                            :multiple="false"
                                                            :disable-branch-nodes="true"
                                                            :disabled="!bool_providerloaded"
                                                            :options="ddProviderList"
                                                            :placeholder="this.utilGetDDLanguage('AG.GP')"
                                                            v-model="obj_DLSPromo.GPI"
                                                            ref="GPI" />
                                            </div>
                                            <div>
                                                <span class="ErrMsg inline inline40" v-if="obj_DLSPromo.PG==1">{{ ValidationPromoErrMsg('CA', 'DLSP', 'CA') }}</span>
                                                <span class="ErrMsg inline inline40" v-if="obj_DLSPromo.PG==2">{{ ValidationPromoErrMsg('NOS', 'DLSP', 'NOS') }}</span>
                                                <span class="ErrMsg inline inline40">{{ ValidationPromoErrMsg('GPI','AG','GP') }}</span>
                                            </div>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveDLSPromo()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </CRow>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["SMB"]["DLSP"]}}</h2>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addDLSPromo()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div v-if="!isSubAgent" class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["PM"]["AGI"]}} :</span>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroupfs"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            @input="AgentGroupChangefs"
                                            v-model="arr_FV['AGI']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["DLSP"]["PN"]}} :</span>
                                <CInput v-model="arr_FV['PN']" size="sm" :value="arr_FV['LN']" @change="v => arr_FV['LN'] = v"></CInput>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PM"]["PG"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_DLSPromoGroup"
                                            :placeholder="this.utilGetDDLanguage('PM.PG')"
                                            v-model="arr_FV['PG']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CI"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_currency"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="arr_FV['CI']" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        </div>
        <div class="container-fluid">
            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>
                        {{this.getLanguage["SMB"]["DLSPL"]}}
                        <div class="custom-tooltip">
                            <i class="fa fa-question-circle"></i>
                            <span class="custom-tooltiptext2 dls-promo">{{getLanguage["PM"]["DLSPS"]}}</span>
                        </div>
                    </strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>


                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <!--<th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.add)">{{getLanguage["PM"]["RS"]}}</th>-->
                                <th>{{ this.getLanguage["PM"]["AGI"] }}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>
                                    {{ this.getLanguage["MEM"]["CI"] }}
                                    <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{ this.getLanguage["DLSP"]["PN"] }}
                                    <i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{ this.getLanguage["PM"]["PG"] }}
                                    <i @click="setSortTable('PG')" :class="setSortLogo('PG')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{ this.getLanguage["DLSP"]["CA"] }} / {{ this.getLanguage["AG"]["GP"] }} / {{ this.getLanguage["DLSP"]["NOS"] }}
                                    <i @click="setSortTable('CA')" :class="setSortLogo('CA')" class="sortlogo"></i>
                                </th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <!--<th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.add)">{{getLanguage["PM"]["RS"]}}</th>-->
                                <th>{{ this.getLanguage["PM"]["AGI"] }}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>
                                    {{ this.getLanguage["MEM"]["CI"] }}
                                    <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{ this.getLanguage["DLSP"]["PN"] }}
                                    <i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{ this.getLanguage["PM"]["PG"] }}
                                    <i @click="setSortTable('PG')" :class="setSortLogo('PG')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{ this.getLanguage["DLSP"]["CA"] }} / {{ this.getLanguage["AG"]["GP"] }} / {{ this.getLanguage["DLSP"]["NOS"] }}
                                    <i @click="setSortTable('CA')" :class="setSortLogo('CA')" class="sortlogo"></i>
                                </th>

                                <!--<th>
                                    {{ this.getLanguage["MEM"]["LPT"] }} / {{ this.getLanguage["PM"]["CA"] }} / {{ this.getLanguage["MEM"]["DT"] }}
                                    <i @click="setSortTable('LG')" :class="setSortLogo('LG')" class="sortlogo"></i>
                                </th>-->
                                <!--<th>
                                    {{ this.getLanguage["PM"]["RM"] }} / {{ this.getLanguage["PM"]["D"] }} / {{ this.getLanguage["PM"]["ED"] }}
                                    <i @click="setSortTable('R')" :class="setSortLogo('R')" class="sortlogo"></i>
                                </th>-->
                                <!--<th>{{ this.getLanguage["PM"]["PA"] }}<i @click="setSortTable('PA')" :class="setSortLogo('PA')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["PM"]["MAX"] }} {{ this.getLanguage["PM"]["AC21"] }}<i @click="setSortTable('MAXBA')" :class="setSortLogo('MAXBA')" class="sortlogo"></i></th>-->
                                <!--<th>{{ this.getLanguage["PM"]["TO"] }}<i @click="setSortTable('TO')" :class="setSortLogo('TO')" class="sortlogo"></i></th>-->
                                <!--<th>{{this.getLanguage["GL"]["SD"]}}<i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i></th>-->
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_DLSPromo.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_DLSPromo">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">
                                <span id="actionBtnCol">
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" style="display: block;">
                                        <i class="cil-trash" @click='removeDLSPromo(data)'></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI)" style="display: block;">
                                        <i class="cil-trash"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <!--<div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.edit)" style="display: block;">
                                        <i class="cil-color-border" @click='editDLSPromo(data.I)'></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>-->
                                </span>
                            </td>
                            <!--<td v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.add)">
                                <CCol col="4">
                                    <label class="switch">
                                        <input type="checkbox" :checked="checkStatus(data.RS)" @click="updateStatus(data)">
                                        <span class="slider round"></span>
                                    </label>
                                </CCol>
                            </td>-->
                            <td>{{ data.GN }} ({{ data.GPC }})</td>
                            <td>
                                <span class="grid-line">{{ renderCurrency(data.ISOC) }}</span>
                            </td>
                            <td>
                                <span class="grid-line bold">{{ data.PN }}</span>
                            </td>
                            <td>
                                <span class="grid-line">{{ renderDLSPromoGroup(data.PG) }}</span>
                            </td>
                            <td v-if="data.PG == 1">
                                <span class="grid-line">{{getLanguage["DLSP"]["CA"]}} = {{ formatNumber(data.CA, 2, data.CS) }}</span>
                            </td>
                            <td v-if="data.PG == 2">
                                <span class="grid-line">{{getLanguage["GAME"]["PROV"]}} = {{ renderProviderName(data.GPN) }}</span>
                                <span class="grid-line">{{getLanguage["DLSP"]["NOS"]}} = {{ data.NOS }}</span>
                            </td>

                            <!--<td>{{ data.GN }} ({{ data.GPC }})</td>
                            <td>
                                <span class="grid-line">{{ renderLoyaltyGroup(data.LG) }}</span>
                                <span class="grid-line">{{ renderConditionAmount(data.MINCA, data.MAXCA, data) }}</span>
                                <span class="grid-line">{{ data.DT }}</span>
                            </td>-->
                            <!--<td>
                                <span class="grid-line">{{ data.R }}</span>
                                <span class="grid-line">{{ getLanguage["PM"]["F"] }}: {{ formatDate(data.PFTS) }}</span>
                                <span class="grid-line">{{ getLanguage["PM"]["T"] }}: {{ formatDate(data.PTTS) }}</span>
                                <span class="grid-line">{{ renderExpiryDuration(data.EDT, data.EDV) }}</span>
                            </td>-->
                            <!--<td class="mwidth200" v-html="renderLoyaltyAmount(data.LG, data.BGame, data.LT, data.MINBA, data.MAXBA, data.BR, data)"></td>-->
                            <!--<td>{{ renderPromotionTurnover(data.TT, data.TV, data.DS, data.TS, data.CS) }}</td>-->
                            <!--<td>{{ formatNumber(data.MAXBA, data.DS, data.TS, 2, data.CS) }}</td>
                            <td v-if="data.ATS == null">-</td>
                            <td v-else>{{ formatDateTime(data.ATS,"YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>-->
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { constDLSPromoGroup } from '@/modules/Constant.js'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import DateRangePicker from 'vue2-daterange-picker'
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters, mapActions } from 'vuex'
    import moment from "moment";
    import genericHelper from "@/modules/GenericHelper.js";
    import { required, numeric, requiredIf, alphaNum, decimal, minValue } from 'vuelidate/lib/validators'
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    Vue.use(require('vue-moment'));

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
        },
        data() {
            return {
                isSubAgent: false,
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_showSearchBar: true,
                bool_isSort: true, // Table Ascending Descending
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_currencyloaded: false,
                bool_providerloaded: false,
                arr_FV: {
                    "PN": "",
                    "PG": null,
                    "AGI": null,
                    "ST": 2,
                    "CI": null,
                    "CTS": {
                        startDate: "",
                        endDate: ""
                    },
                },
                arr_DLSPromo: [],
                obj_DLSPromo: {
                    "I": 0,
                    "RS": 2,
                    "AGI": "",
                    "AGIT": null,
                    "PN": "",
                    "PG": null,
                    "GPI": null,
                    "CA": 0.00,
                    "NOS": 0,
                    "CI": 0,
                },
                dd_agentgroup: [],
                dd_agentgroupfs: [],
                dd_DLSPromoGroup: [],
                dd_DLSPromoStatus: [],
                ddProviderList: [],
                bool_gameloaded: false,
                bool_DLSPromoCV: false,
                agentGroupId: 0,
                dd_currency: [],
                dd_currency2: [],
                constAccessType: constAccessType
            }
        },
        validations: {
            obj_DLSPromo: {
                "PN": { required },
                "AGIT": { required },
                "PG": { required },
                "CI": { required },
                "CA": {
                    required: requiredIf(function (vm) {
                        return vm.PG == 1;
                    }), decimal, minValueValue: minValue(0)
                },
                "NOS": {
                    required: requiredIf(function (vm) {
                        return vm.PG == 2;
                    }), decimal, minValueValue: minValue(0)
                },
                "GPI": {
                    required: requiredIf(function (vm) {
                        return vm.PG == 2;
                    }), numeric
                }

            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_DLSPromoCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getDLSPromoList();
            },
        },
        methods: {
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            checkModuleAccess2(type) {
                return this.checkModuleAccess('DLSP', 'P', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_DLSPromoCV = false;
                this.bool_currencyloaded = false;
                this.bool_providerloaded = false;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getDLSPromoList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getDLSPromoList();
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getDLSPromoList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            CurrencyChange(value) {
                if (value != undefined) {
                    var that = this;
                    this.dd_currency.find(function (val, idx) {
                        if (val.id == value) {
                            that.setThousandCurrency(that.CheckIsThousandCurrency(val.label, that), that);
                        }
                    });
                }

                this.RenderCurrencyChange(value);
            },
            RenderCurrencyChange(value) {
                var that = this;
                this.bool_providerloaded = false;

                this.getDataApi(`/api/dd/game/frbprovbycategory/` + this.agentGroupId + `/` + value,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.bool_providerloaded = true;
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label);
                            }

                            that.ddProviderList = d.dropdownlist;

                            if (that.obj_DLSPromo.I <= 0) {
                                that.obj_DLSPromo.GPI = null;
                            }
                        }
                    });

            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                        this.searchPAgi = agi;
                    } else {
                        this.searchPAgi = 0;
                    }

                } else {
                    this.searchPAgi = 0;
                    this.arr_FV['AGI'] = null;
                }
                this.arr_FV['CI'] = null;
                this.dd_currency = null;
                this.getCurrencyList();
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
            },
            renderCurrency(ISOC) {
                return this.getLanguage['DB'][ISOC];
            },
            getDropdownList() {
                var that = this;

                this.dd_DLSPromoGroup = [{
                    id: 1,
                    label: this.getLanguage["MEM"]["FC"]
                }, {
                    id: 2,
                    label: this.getLanguage["MEM"]["FS"]
                    }];

                this.dd_DLSPromoStatus = [{
                    id: "2",
                    label: this.getLanguage["GL"]["AC"]
                }, {
                    id: "1",
                    label: this.getLanguage["GL"]["IAC"] + " / " + this.getLanguage["PM"]["PAST"]
                }];

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            renderDLSPromoGroup(int_DLSPromoGroup) {
                return this.dd_DLSPromoGroup[int_DLSPromoGroup - 1].label;
                //var DLSPromoGroup = "";
                //for (var i = 0; i < constDLSPromoGroup.length; i++) {
                //    if (constDLSPromoGroup[i].id == int_DLSPromoGroup) {
                //        DLSPromoGroup = constDLSPromoGroup[i].label;
                //        break;
                //    }
                //}

                //return DLSPromoGroup;
            },
            loadProviderOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/game/provbycategory/` + agi,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label);
                            }

                            that.ddProviderList = d.dropdownlist;
                        }
                        //else {
                        //    that.ddProviderList = null;
                        //}

                        callback();
                    });
            },
            getDLSPromoList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }

                    path += (
                        "f.PN=" + (this.arr_FV["PN"] == null ? "" : this.arr_FV["PN"]) +
                        "&f.PG=" + (this.arr_FV["PG"] == null ? "" : this.arr_FV["PG"]) +
                        "&f.ST=" + (this.arr_FV["ST"] == null ? "" : this.arr_FV["ST"]) +
                        "&f.CI=" + (this.arr_FV["CI"] == null ? "" : this.arr_FV["CI"]) +
                        "&f.ATAGI=" + (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"]));

                    //if (this.arr_FV.CTS.startDate != "") {
                    //    var cts_from = this.parseDateToJsonString(this.arr_FV.CTS.startDate);
                    //    path += "&f.CTS_from=" + cts_from;
                    //}
                    //if (this.arr_FV.CTS.endDate != "") {
                    //    var cts_to = this.parseDateToJsonString(this.arr_FV.CTS.endDate);
                    //    path += "&f.CTS_to=" + cts_to;
                    //}
                }

                this.getDataApi(`/api/dlspromo/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_DLSPromo = d.D.Items;
                            that.isSubAgent = d.D.Items[0].ISA;
                            that.resizeTableHead();
                        }
                    });
            },
            AgentGroupChange(value) {
                this.RenderAgentGroupChange(value, true);
            },
            RenderAgentGroupChange(value, isReset) {
                var that = this;
                this.bool_gameloaded = false;
                this.bool_currencyloaded = false;
                //this.bool_providerloaded = false;

                var agi = 0;

                if (value != "") {
                    agi = value.split("-")[1];
                }
                this.agentGroupId = agi;
                this.agi = agi;

                this.getDataApi('/api/dd/cur/' + agi,
                    function (d, s) {
                        if (s) {
                            that.bool_currencyloaded = true;
                            that.dd_currency2 = d.dropdownlist;
                            if (that.obj_DLSPromo.I > 0) {
                                that.CurrencyChange(that.obj_DLSPromo.CI);
                            }
                            if (isReset) {
                                that.obj_DLSPromo.CI = null;
                                that.obj_DLSPromo.GPI = null;
                            }
                        }
                    });

                //this.getDataApi(`/api/dd/game/frbprovbycategory/` + agi,
                //    function (d, s) {
                //        if (s && d && d.dropdownlist) {
                //            that.bool_providerloaded = true;
                //            for (var i = 0; i < d.dropdownlist.length; i++) {
                //                d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label);
                //            }

                //            that.ddProviderList = d.dropdownlist;
                //        }
                //    });
            },
            ValidationPromoErrMsg(value, langKey1 = "", langKey2 = "") {
                if (this.bool_DLSPromoCV) {
                    if (langKey1 == "") {
                        langKey1 = "PM";
                    }

                    if (langKey2 == "") {
                        langKey2 = value;
                    }

                    var validateObj = this.$v.obj_DLSPromo[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.alphaNum != undefined && !validateObj.alphaNum) {
                        return String.format(this.utilGetErrorLanguage('1008'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.numeric != undefined && !validateObj.numeric) {
                        return String.format(this.utilGetErrorLanguage('1009'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.between != undefined && !validateObj.between) {
                        return String.format(this.utilGetErrorLanguage('1004'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.minValueValue != undefined && !validateObj.minValueValue) {
                        return String.format(this.utilGetErrorLanguage('4442'), this.getLanguage[langKey1][langKey2]);
                    }

                }
            },
            addDLSPromo() {
                this.bool_DLSPromoCV = false;
                this.bool_fullLoading = true;

                this.obj_DLSPromo = {
                    "I": 0,
                    "RS": 2,
                    "AGI": "",
                    "AGIT": null,
                    "PN": "",
                    "PG": null,
                    "CA": 0,
                    "NOS": 0,
                    "GPI": null,
                    "CI": null
                };
                this.bool_isAMV = true;
                this.bool_fullLoading = false;

                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && that.dd_agentgroup.length < 2) {
                        this.obj_DLSPromo.AGIT = this.dd_agentgroup[0].id;
                        this.AgentGroupChange(this.obj_DLSPromo.AGIT);
                    }
                }

            },
            editDLSPromo(id) {
                var that = this;

                this.bool_fullLoading = true;
                this.bool_groupCV = false;
                this.bool_DLSPromoCV = false;

                this.getDataApi(`/api/dlspromo/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.obj_DLSPromo = Object.assign(that.obj_DLSPromo, d.D);

                            if (that.obj_DLSPromo.AGI != 0) {
                                that.obj_DLSPromo.AGIT = "3-" + that.obj_DLSPromo.AGI;
                                that.RenderAgentGroupChange(that.obj_DLSPromo.AGIT, false);
                            }

                            that.bool_isAMV = true;
                        }
                    });
            },
            saveDLSPromo() {
                var that = this;
                if (this.obj_DLSPromo.AGIT != null && this.obj_DLSPromo.AGIT.length > 0) {
                    var agi = this.obj_DLSPromo.AGIT.split("-");
                    this.obj_DLSPromo.AGI = agi[1];
                }

                //if (this.obj_DLSPromo.GPI != null ) {
                //    var gpi = this.obj_DLSPromo.GPI.split("-");
                //    this.obj_DLSPromo.GPI = gpi[1];
                //}

                this.bool_DLSPromoCV = true;
                this.$v.obj_DLSPromo.$touch();
                var formValid = true;

                if (!this.$v.obj_DLSPromo.$error && formValid) {
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    this.postDataApi(`/api/dlspromo/s`, this.obj_DLSPromo,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.getDLSPromoList();
                            }
                        });
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_DLSPromo"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            removeDLSPromo(d) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI
                        };

                        this.postDataApi(`/api/dlspromo/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getDLSPromoList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                                else {
                                    if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 13001) {
                                        this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.13001")));
                                    }
                                }
                            });
                    }
                });
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
        },
        created() {
            this.$parent.showSubMenu = 'P';
            this.$parent.showActiveMenu = 'P.DLSP';
            if (this.$route.query.agi) {
                this.arr_FV['AGI'] = this.$route.query.agi;
            }
            this.getDropdownList();
            this.getCurrencyList();
            this.getDLSPromoList();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        },
    }
</script>

<style>
    #outer {
        overflow: hidden;
    }

    #bottom {
        display: none
    }

    #outer:hover #bottom {
        display: block;
        position: absolute;
        left: 50;
        top: 50;
        border: 1px solid blue;
        background-color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Promotion/DLSPromotion.vue